var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333252 2C0.333252 0.895433 1.22868 0 2.33325 0H11.6666C12.7712 0 13.6666 0.895431 13.6666 2V2.84511C14.0651 3.07567 14.3331 3.50653 14.3331 4V8C14.3331 8.49347 14.0651 8.92433 13.6666 9.15489V10C13.6666 11.1046 12.7712 12 11.6666 12H2.33325C1.22868 12 0.333252 11.1046 0.333252 10V2ZM12.3333 2V2.66667H8.33325C7.59687 2.66667 6.99992 3.26362 6.99992 4V8C6.99992 8.73638 7.59687 9.33333 8.33325 9.33333H12.3333V10C12.3333 10.3682 12.0348 10.6667 11.6666 10.6667H2.33325C1.96506 10.6667 1.66659 10.3682 1.66659 10V2C1.66659 1.63181 1.96506 1.33333 2.33325 1.33333H11.6666C12.0348 1.33333 12.3333 1.63181 12.3333 2ZM8.33325 4H12.9998V8L8.33325 8V4ZM11.6666 6C11.6666 6.55228 11.2189 7 10.6666 7C10.1143 7 9.66659 6.55228 9.66659 6C9.66659 5.44772 10.1143 5 10.6666 5C11.2189 5 11.6666 5.44772 11.6666 6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.56266ed4.svg";
export { ForwardRef as ReactComponent };